document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll(
    'details:has(> summary.header__menu-item)'
  );

  menuItems.forEach(function(details) {
    let closeTimer;
    details.addEventListener('mouseenter', function() {
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
    });
    details.addEventListener('mouseleave', function() {
      closeTimer = setTimeout(function() {
        details.removeAttribute('open');
      }, 150);
    });
  });
});
